!(function (w, d, s, t, a) {
  if (w.amzn) return;
  w.amzn = a = function () {
    w.amzn.q.push([arguments, new Date().getTime()]);
  };
  a.q = [];
  a.version = "0.0";
  s = d.createElement("script");
  s.src = "https://c.amazon-adsystem.com/aat/amzn.js";
  s.id = "amzn-pixel";
  s.async = true;
  t = d.getElementsByTagName("script")[0];
  t.parentNode.insertBefore(s, t);
})(window, document);
amzn("setRegion", "NA");
amzn("addTag", "c1eca9bc-371c-4c79-876f-0b555ef707a3");
amzn("trackEvent", "PageView");

// Track email capture form submissions
document.addEventListener("DOMContentLoaded", function () {
  const formsWithEmail = document.querySelectorAll("form");

  formsWithEmail.forEach((form) => {
    const emailInput = form.querySelector('input[type="email"]');

    if (emailInput) {
      form.addEventListener("submit", function () {
        if (typeof amzn !== "undefined") {
          amzn("trackEvent", "EmailCapture");
        }
      });
    }
  });
});
